export default "__VITE_ASSET__f8118df7__"